<template>
  <div class="clientManage">
    <div class="name">
      {{ moduleTitle }}
    </div>
    <div class="btns">
      <el-button
        type="primary"
        size="small"
        class="addClient"
        @click="addClient"
      >
        添加应用
      </el-button>
      <div class="searchBox">
        <el-input
          v-model="searchText"
          placeholder="支持搜索应用ID/应用名称/根URL"
          @keyup.enter.native="getClientList"
        ></el-input>
        <span class="iconBox" @click="getClientList">
          <i class="icon icon-search"></i>
        </span>
      </div>
    </div>

    <el-table :data="tableData" tooltip-effect="light" style="width: 100%">
      <el-table-column
        label="应用ID"
        prop="clientID"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="应用名称"
        prop="clientName"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="根URL"
        prop="rootUrl"
        class-name="rootUrl"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="enable"
        label="启用状态"
        width="120px"
        align="center"
      >
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.enable"
            @input="enableChange(scope.row.enable, scope.row.id)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200px"
        align="center"
        class-name="options td-pt1"
      >
        <template slot-scope="scope">
          <span class="textBtn" @click="handleDetail(scope.row.id)">
            详情
          </span>
          <span class="textBtn delete" @click="handleDelete(scope.row.id)">
            删除
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next"
      :page-size="pageSize"
      :current-page.sync="pageNum"
      :total="total"
      @current-change="pageChange"
    >
    </el-pagination>
    <el-dialog
      :title="tipTitle"
      width="500px"
      :visible.sync="dialogRemoveOrAnable"
    >
      <div class="deleteText">
        {{ tipText }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemoveOrAnable"
          >确 定</el-button
        >
        <el-button @click="dialogRemoveOrAnable = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import APIS from "@/apis/clientManage.js"
// import Base16 from '@/common/base16.js'
// import { timeFormat } from '@/common/utils.js'

// import {
//   getStore
// } from '@/common/utils.js'
export default {
  data() {
    return {
      moduleTitle: "应用列表",
      searchText: null,//搜索关键字
      dialogRemoveOrAnable: false,
      currentFlag: "delete",
      tableData: [],
      enterpriseId: "",
      breadcrumb: [
        {
          label: "应用管理"
        }
      ],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      realmName: this.$realm,
      currentClientId: ""
    }
  },
  computed: {
    tipText() {
      return this.currentFlag === "delete"
        ? "确认删除这个应用吗？"
        : this.currentFlag === "enable"
        ? "确认启用这个应用吗？"
        : "确认禁用这个应用吗？"
    },
    tipTitle() {
      return this.currentFlag === "delete"
        ? "删除提示"
        : this.currentFlag === "enable"
        ? "启用提示"
        : "禁用提示"
    }
  },
  mounted() {
    this.getClientList()
  },
  methods: {
    // 查询账户列表 new
    async getClientList() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        search: this.searchText
      }
      let { status, data } = await APIS.getRealmsClients(this.realmName, {
        params
      })
      this.total = 0
      this.tableData = []
      if (status === 0) {
        this.total = data.totalCount || 0
        this.tableData = []
        if (data && data.list) {
          this.tableData = data.list.map((item, index) => {
            return {
              index: index,
              clientName: item.name,
              rootUrl: item.rootUrl,
              enable: item.enabled,
              clientID: item.clientId,
              id: item.id
            }
          })
        }
      }
    },
    // 删除账户
    async deleteClient() {
      let { status } = await APIS.deleteRealmsClientInfo(
        this.realmName,
        this.currentClientId
      )
      this.dialogRemoveOrAnable = false
      if (status === 0) {
        if (this.total === 1) {
          this.pageNum = 1
        } else if ((this.total - 1) % this.pageSize === 0) {
          this.pageNum -= 1
        }
        this.getClientList()
      }
    },
    // 更新账户的启用、禁用状态
    async updateClientInfor() {
      let currentClient = this.tableData.find(
        item => item.id === this.currentClientId
      )
      if (currentClient && currentClient.enable !== undefined) {
        let params = {
          enabled: !currentClient.enable
        }
        let { status } = await APIS._putRealmsClientInfo(
          this.realmName,
          this.currentClientId,
          { data: params }
        )
        this.dialogRemoveOrAnable = false
        if (status === 0) {
          currentClient.enable = !currentClient.enable
        }
      }
    },
    // 翻页
    pageChange() {
      this.getClientList()
    },
    // 添加应用
    addClient() {
      this.$router.push("/clientManage/addClient")
    },
    // 查看详情
    handleDetail(id) {
      this.$router.push({
        path: "/clientManage/detailClient",
        query: {
          clientId: id
        }
      })
    },
    // 打开删除账户弹窗
    handleDelete(id) {
      this.currentFlag = "delete"
      this.currentClientId = id
      this.dialogRemoveOrAnable = true
    },
    // 启用状态改变，打开提示确认弹窗
    enableChange(enable, id) {
      this.currentFlag = !enable ? "enable" : ""
      this.dialogRemoveOrAnable = true
      this.currentClientId = id
    },
    // 提交删除、启用、禁用状态
    submitRemoveOrAnable() {
      if (this.currentFlag === "delete") {
        this.deleteClient()
      } else {
        this.updateClientInfor()
      }
    }
  }
}
</script>

<style lang="scss">
.clientManage {
  .name {
    display: none; //暂时隐藏
  }
  .btns {
    margin: 0 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .searchBox {
      display: inline-flex;
      width: 255px;
      .iconBox {
        width: 30px;
        background-color: rgba(22, 155, 213, 1);
        flex-shrink: 0;
        text-align: center;
        line-height: 26px;
        cursor: pointer;
      }
    }
  }
  .el-dialog {
    &__title {
      color: #333333;
      font-weight: 600;
    }
    &__body {
      // padding: 0 50px;
      .deleteText {
        text-align: center;
        height: 50px;
        line-height: 50px;
      }
    }
  }
}
</style>
